import React, { useContext, useState } from "react";
import { Router } from "next-routes";
import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { AuthError } from "@firebase/auth-types";

import { GenericLogin, GenericLoginProps } from "./GenericLogin";
import { LOGIN } from "../../modules/checkout/constants";
import { router } from "../../routes";
import { FirebaseContext } from "../../../pages/FirebaseProvider";

const onLogin = ({
  business,
  formId,
  Router,
  firebase,
  setLoginStatus
}: {
  business: string;
  formId: string;
  Router: Router;
  firebase: any;
  setLoginStatus: any;
}): GenericLoginProps["onSubmit"] => ({ user, password }) =>
  firebase!.auth
    .signInWithEmailAndPassword(user, password)
    .then(() => {
      setLoginStatus("");
      Router.push(`/${business}/form/${formId}/quote`);
    })
    .catch((err: AuthError) => setLoginStatus(err.code));

type WithLoginForm = <T>(Component: React.ComponentType<T>) => React.ComponentType<T>;

export const withLoginForm: WithLoginForm = Component => props => {
  const { Router } = router;
  const [loginStatus, setLoginStatus] = useState("");
  const t = useFormatMessage();

  if (!Router.router) {
    return null;
  }
  const { business, formId, formStatus } = Router.router.query;
  const firebase = useContext(FirebaseContext);

  return formStatus === LOGIN ? (
    <GenericLogin
      onSubmit={onLogin({ business, formId, Router, firebase, setLoginStatus })}
      warningMessage={loginStatus && t(loginStatus)}
    />
  ) : (
    <Component {...props} />
  );
};
